export default __webpack_public_path__ + "static/media/HOMBRESILUETA.e79ada79.png";